/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import Heading from '@react/react-spectrum/Heading';
import Well from '@react/react-spectrum/Well';

import ConnectionMethod from '../connection.method';
import PinField from '../pin.field';
import SessionForm from '../session.form';

import styles from './styles/session.details.modal.styl';

const SessionDetailsContent = ({
  detailsForm,
  izzy,
  link,
  nameField,
  pin,
  urlField
}) => (
  <div>
    <div>
      <Heading variant="subtitle3">
        Session Info
      </Heading>
      <Well>
        <SessionForm
          className={styles.form}
          sessionForm={detailsForm}
          izzy={izzy}
          nameField={nameField}
          urlField={urlField}
        />
      </Well>
    </div>
    <div>
      <Heading variant="subtitle3">
        Connect Device and Enter PIN
      </Heading>
      <Well>
        <ConnectionMethod
          className={styles.connectionMethod}
          izzy={izzy}
          link={link}
        />
        <PinField
          izzy={izzy}
          pin={pin}
        />
      </Well>
    </div>
  </div>
);

SessionDetailsContent.displayName = 'SessionDetailsContent';

export default SessionDetailsContent;
